
export const productSuggestionListProps = () => ({
  products: {
    type: Array,
    default: null
  },
  keyWord: {
    type: String,
    default: ""
  }
})

export const useProductSuggestionList = (props) => {
  const maxProductsNumber = 3;

  const maxProductsToDisplay = computed(() => {
    return props.products.slice(0, maxProductsNumber);
  })

  return {
    maxProductsToDisplay
  }
}